import { RouteDetail } from "../../RouteDetail";
import { SectionMenu } from "..";
import { memo } from "react";
import { overrideTabs } from "../../../consts/tabs";

export const OverrideSections = memo(() => {
  return (
    <SectionMenu tabs={overrideTabs} activeTab={0}>
      <SectionMenu.SectionMenuItem id={0}>
        <RouteDetail />
      </SectionMenu.SectionMenuItem>
    </SectionMenu>
  );
});
